import commonMessages from '../locales/shared';
export default {
    data() {
        this.$i18n.locale = 'en';
        return {
            locale: 'en'
        }
    },
    i18n: {
        sharedMessages: commonMessages
    },
    watch: {
        locale (val) {
            this.$i18n.locale = val;
        }
    }
};